import React from 'react';
import { get } from 'lodash';
import classnames from 'classnames';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';
import { themes } from 'Components/frameworks/block-link/BlockLink.themes';
import { WebCallbackTrigger } from './WebCallbackTrigger';

export type WebCallbackBlockLinkProps = {
  icon: IconName,
  texts: Array<string | Node>,
  theme: string,
  trackingData: {|
    actionGA: string,
  |},
};

export const WebCallbackBlockLink = ({
  icon,
  trackingData,
  texts,
  theme = 'default',
}: WebCallbackTriggerProp) => (
  <WebCallbackTrigger trackingData={trackingData} theme={theme}>
    <Icon
      className={classnames('flex-shrink-0', themes[theme].thIcon)}
      name={icon}
      width={themes[theme].thIconWidth}
    />
    <span className="rtl:text-left">
      {texts.map((text, idx) => (
        <div className={get(themes[theme], `customText${idx}`, '')} key={text}>
          {text}
        </div>
      ))}
    </span>
  </WebCallbackTrigger>
);
